import { _get } from 'frontcore/utils/communications/apiClient'
import { PatternAPIResponse } from 'frontcore/presentation/perimeter-finder/domain/types'
import { URL_BASE_PATTERNS } from 'frontcore/presentation/perimeter-finder/constants'

interface PatternAPIClient {
    request: () => Promise<PatternAPIResponse[]>
}

export default class PatternHttpAPI implements PatternAPIClient {

  async request (): Promise<PatternAPIResponse[]> {
    const url = `${URL_BASE_PATTERNS}`
    const perimeter = await _get(url)
    return perimeter as PatternAPIResponse[]
  }
}
